// https://app.growthbook.io/features/pen-5375_v1
export const PEN_5375_V1_TWO_PAGE_QR_FLAG = 'pen-5375_v1'
